import apiClient from "../../apiClient/apiClient";
import endPoints from "./endPoints";
import { EmployeePledgeApiType } from "./types/apiTypes";

const employeePledgeApi: EmployeePledgeApiType = {
  getLookups: () => apiClient.get(endPoints.employeePledge.getLookups()),
  get: (campaignId: string) =>
    apiClient.get(endPoints.employeePledge.get(campaignId)),
  getContributor: (contributorId: string) =>
    apiClient.get(endPoints.employeePledge.getContributor(contributorId)),
  save: (payload) => apiClient.post(endPoints.employeePledge.save(), payload),
  authenticate: (payload) =>
    apiClient.post(endPoints.employeePledge.authenticate(), payload),
  getActivePastCampaigns: () =>
    apiClient.get(endPoints.employeePledge.getActivePastCampaigns()),
};

export default employeePledgeApi;
